export const STREAMING = {
  spotify: "https://open.spotify.com/artist/7b7diUdBFLFXusGDruMX1g",
  appleMusic: "https://music.apple.com/us/artist/sylas-ever/1877016472",
  youtube: "https://www.youtube.com/@SylasEver",
  instagram: "https://www.instagram.com/sylasever1/",
  tiktok: "https://www.tiktok.com/@sylasever",
};

// Primary "Listen Now" target
export const LISTEN_NOW = STREAMING.spotify;

// Upcoming single — pre-save
export const UPCOMING = {
  title: "Be Alright",
  release_date: "June 22, 2026",
  cover: "https://customer-assets.emergentagent.com/job_moonlit-coast/artifacts/n3zhbei7_IMG_3120.jpg",
  presave_url: "https://lnk.to/BeAlrightSylasEver",
};
